// src/content/guide.js
// Notices shown before the flow. TODO(K8): approve wording.

export const COOKIE_NOTICE = {
  title: "Before you start: one cookie to save your work",
  points: [
    "We use one functional cookie so the tool can save your progress. No tracking, no advertising, no analytics.",
    "Your answers are stored on our server so you can continue later or on another device with your resume link.",
    "Everything is deleted automatically 30 days after your last visit. You can delete it yourself at any time.",
    "When you ask for AI suggestions (steps 5 and 7), your answers are sent to Mistral AI, a European AI provider.",
    "Please do not enter personal data (names, emails) in the text fields.",
  ],
  // TODO(K8): approve wording
};
